import {
  gql
} from "@apollo/client";

export const CHARGERS = gql`
  query Chargers($chargers_n: Int, $chargers_where: ChargerSearchFilter, $errors_n: Int, $after: String) {
    chargers(n: $chargers_n, after: $after, where: $chargers_where) @connection(key: "chargersOverview") {
      edges {
        cursor
        node {
          serial
          salesforce_details {
            last_heartbeat
            last_status_notification
            vpn_ip
            ocpp_status
            ocpp_server
            firmware_version
          }
          charger_status_messages(n: $errors_n) {
            edges {
              cursor
              node {
                errorCode
                receiveTimestamp
                serial
                status
                vendorErrorCode
              }
            }
          }
          vpn_status {
            connections {
              allowed_ips
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CHARGER_STATUS_MESSAGES = gql`
  query charger_status_messages($n: Int, $after: String, $where: InputChargerStatusEntryOperators, $distinct_by: [ChargerStatusEntryKeys]) {
    charger_monitors @connection(key: "chargerErrors") {
      charger_status_messages(n: $n, after: $after, where: $where, distinct_by: $distinct_by) {
        edges {
          node {
            errorCode
            receiveTimestamp
            serial
            status
            vendorErrorCode
          }
        }
      }
    }
  }
`;

export const STATUSES = gql`
  query Statuses {
    charger_monitors @connection(key: "chargerStatuses") {
      status {
        dashboard_ocpp_status_frequencies {
          Available
          Charging
          Faulted
          Finishing
          Offline
          Preparing
          SuspendedEV
          SuspendedEVSE
          Unavailable
        }
      }
    }
  }
`;

export const FIRMWARE_VERSIONS = gql`
  query Firmware_versions($n: Int, $after: String, $where: ChargerSearchFilter) {
    chargers(n: $n, after: $after, where: $where) @connection(key: "firmwareVersions") {
      edges {
        node {
          salesforce_details {
            firmware_version
          }
        }
      }
    }
  }
`;

export const SITES_COUNT = gql`
  query Sites_count($n: Int) {
    sites(n: $n) @connection(key: "sitesCount") {
      totalCount
    }
  }
`;

export const VIDS_COUNT = gql`
  query Vids_count($n: Int) {
    vehicles(n: $n) @connection(key: "vidsCount") {
      totalCount
    }
  }
`;
